(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('toggle',(event)=>{
  const selector=event.target;
  if(!selector.matches('[data-country-selector]')||!selector.open)return;
  document.querySelectorAll('[data-country-selector][open]').forEach((item)=>{
    if(item!==selector)item.removeAttribute('open');
  });
},true);

document.addEventListener('click',(event)=>{
  if(event.target.closest('[data-country-selector]'))return;
  document.querySelectorAll('[data-country-selector][open]').forEach((item)=>item.removeAttribute('open'));
});

document.addEventListener('keydown',(event)=>{
  if(event.key!=='Escape')return;
  document.querySelectorAll('[data-country-selector][open]').forEach((item)=>{
    const summary=item.querySelector('summary');
    item.removeAttribute('open');
    if(summary)summary.focus({preventScroll:true});
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
(() => {const mobile=window.matchMedia('(max-width: 749px)');const syncMenus=()=>{document.querySelectorAll('[data-footer-menu]').forEach((menu)=>{if(mobile.matches){if(menu.dataset.mobileReady!=='true'){menu.open=false;menu.dataset.mobileReady='true'}}else{menu.open=true;delete menu.dataset.mobileReady}})};syncMenus();mobile.addEventListener?.('change',syncMenus);document.addEventListener('shopify:section:load',syncMenus)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
let mobileSearchReturnFocus = null;

const getFocusableElements = (container) => Array.from(container.querySelectorAll(focusableSelector)).filter((element) => !element.hidden && element.getClientRects().length > 0);

const trapFocus = (event, container) => {
  if (event.key !== 'Tab') return;
  const focusable = getFocusableElements(container);
  if (!focusable.length) {
    event.preventDefault();
    container.focus();
    return;
  }
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
};

const syncBodyLock = () => {
  const drawerOpen = Boolean(document.querySelector('.mobile-nav-drawer[open]'));
  const searchOpen = Boolean(document.querySelector('[data-mobile-search-modal]:not([hidden])'));
  document.body.classList.toggle('site-overlay-open', drawerOpen || searchOpen);
};

const closeMobileDrawer = (drawer, restoreFocus = true) => {
  if (!drawer || !drawer.open) return;
  const toggle = drawer.querySelector('.mobile-nav-drawer__toggle');
  if (restoreFocus && toggle) toggle.focus({ preventScroll: true });
  drawer.removeAttribute('open');
  syncBodyLock();
};

const openMobileSearch = (trigger) => {
  const dialogId = trigger.getAttribute('aria-controls');
  const dialog = dialogId ? document.getElementById(dialogId) : null;
  const modal = dialog ? dialog.closest('[data-mobile-search-modal]') : null;
  if (!modal) return;
  const openDrawer = document.querySelector('.mobile-nav-drawer[open]');
  if (openDrawer) closeMobileDrawer(openDrawer, false);
  mobileSearchReturnFocus = trigger;
  modal.hidden = false;
  syncBodyLock();
  requestAnimationFrame(() => {
    const input = modal.querySelector('[data-mobile-search-input]');
    if (input) input.focus({ preventScroll: true });
    else dialog.focus({ preventScroll: true });
  });
};

const closeMobileSearch = (modal, restoreFocus = true) => {
  if (!modal || modal.hidden) return;
  if (restoreFocus && mobileSearchReturnFocus && mobileSearchReturnFocus.isConnected) {
    mobileSearchReturnFocus.focus({ preventScroll: true });
  } else if (modal.contains(document.activeElement)) {
    document.activeElement.blur();
  }
  modal.hidden = true;
  syncBodyLock();
  mobileSearchReturnFocus = null;
};

document.addEventListener('toggle', (event) => {
  const opened = event.target;
  if (opened.matches('[data-desktop-menu]') && opened.open) {
    document.querySelectorAll('[data-desktop-menu][open]').forEach((menu) => {
      if (menu !== opened) menu.removeAttribute('open');
    });
    return;
  }
  if (opened.matches('[data-mobile-menu]')) {
    syncBodyLock();
    if (opened.open) {
      const closeButton = opened.querySelector('[data-mobile-menu-close]:not(.mobile-nav-drawer__overlay)');
      if (closeButton) requestAnimationFrame(() => closeButton.focus({ preventScroll: true }));
    }
  }
}, true);

document.addEventListener('click', (event) => {
  const searchTrigger = event.target.closest('[data-mobile-search-open]');
  if (searchTrigger) {
    openMobileSearch(searchTrigger);
    return;
  }

  const searchClose = event.target.closest('[data-mobile-search-close]');
  if (searchClose) {
    closeMobileSearch(searchClose.closest('[data-mobile-search-modal]'));
    return;
  }

  const searchModal = event.target.closest('[data-mobile-search-modal]');
  if (searchModal && event.target === searchModal) {
    closeMobileSearch(searchModal);
    return;
  }

  const closeControl = event.target.closest('[data-mobile-menu-close]');
  if (closeControl) {
    closeMobileDrawer(closeControl.closest('.mobile-nav-drawer'));
    return;
  }

  if (!event.target.closest('[data-desktop-menu]')) {
    document.querySelectorAll('[data-desktop-menu][open]').forEach((menu) => menu.removeAttribute('open'));
  }
});

document.addEventListener('keydown', (event) => {
  const searchModal = document.querySelector('[data-mobile-search-modal]:not([hidden])');
  if (searchModal) {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeMobileSearch(searchModal);
      return;
    }
    trapFocus(event, searchModal.querySelector('[role="dialog"]'));
    return;
  }

  const mobileDrawer = document.querySelector('.mobile-nav-drawer[open]');
  if (mobileDrawer) {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeMobileDrawer(mobileDrawer);
      return;
    }
    trapFocus(event, mobileDrawer.querySelector('.mobile-nav-drawer__panel'));
    return;
  }

  if (event.key === 'Escape') {
    document.querySelectorAll('[data-desktop-menu][open]').forEach((menu) => menu.removeAttribute('open'));
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-brands-directory"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const directories = document.querySelectorAll('[data-brand-directory]');

    directories.forEach((directory) => {
      if (directory.dataset.brandDirectoryReady === 'true') return;
      directory.dataset.brandDirectoryReady = 'true';

      const search = directory.querySelector('[data-brand-search]');
      const count = directory.querySelector('[data-brand-count]');
      const empty = directory.querySelector('[data-brand-empty]');
      const alphabet = directory.querySelector('[data-brand-alphabet]');
      const items = [...directory.querySelectorAll('[data-brand-item]')];
      const groups = [...directory.querySelectorAll('[data-brand-group]')];

      if (!search || !alphabet || !items.length) return;

      let activeLetter = 'all';

      const setActiveLetter = (letter) => {
        activeLetter = letter;
        alphabet.querySelectorAll('[data-brand-letter]').forEach((button) => {
          const active = button.dataset.brandLetter === letter;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      };

      const applyFilter = () => {
        const query = search.value.trim().toLocaleLowerCase();
        let visibleCount = 0;

        items.forEach((item) => {
          const matchesLetter = activeLetter === 'all' || item.dataset.brandLetter === activeLetter;
          const matchesQuery = query === '' || (item.dataset.brandName || '').includes(query);
          const visible = matchesLetter && matchesQuery;
          item.hidden = !visible;
          if (visible) visibleCount += 1;
        });

        groups.forEach((group) => {
          group.hidden = !group.querySelector('[data-brand-item]:not([hidden])');
        });

        if (count) count.textContent = `${visibleCount} ${visibleCount === 1 ? 'brand' : 'brands'}`;
        if (empty) empty.hidden = visibleCount !== 0;
      };

      alphabet.addEventListener('click', (event) => {
        const button = event.target.closest('[data-brand-letter]');
        if (!button) return;
        setActiveLetter(button.dataset.brandLetter || 'all');
        applyFilter();
      });

      search.addEventListener('input', () => {
        if (search.value.trim() !== '' && activeLetter !== 'all') setActiveLetter('all');
        applyFilter();
      });

      applyFilter();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-faq-help"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-faq-help]').forEach((root) => {
      if (root.dataset.faqReady === 'true') return;
      root.dataset.faqReady = 'true';

      const search = root.querySelector('[data-faq-search]');
      const filters = Array.from(root.querySelectorAll('[data-faq-filter]'));
      const items = Array.from(root.querySelectorAll('[data-faq-item]'));
      const count = root.querySelector('[data-faq-count]');
      const empty = root.querySelector('[data-faq-empty]');
      let activeCategory = 'all';

      const update = () => {
        const query = (search?.value || '').trim().toLowerCase();
        let visible = 0;

        items.forEach((item) => {
          const matchesCategory = activeCategory === 'all' || item.dataset.faqCategory === activeCategory;
          const matchesQuery = !query || (item.dataset.faqText || '').includes(query);
          const show = matchesCategory && matchesQuery;
          item.hidden = !show;
          if (show) visible += 1;
        });

        if (count) count.textContent = visible === 1 ? (section.dataset.answerOne || '1 answer') : (section.dataset.answers || '__COUNT__ answers').replace('__COUNT__', String(visible));
        if (empty) empty.hidden = visible !== 0;
      };

      filters.forEach((button) => {
        button.addEventListener('click', () => {
          activeCategory = button.dataset.faqFilter || 'all';
          filters.forEach((candidate) => {
            const selected = candidate === button;
            candidate.classList.toggle('is-active', selected);
            candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
          update();
        });
      });

      search?.addEventListener('input', update);
      search?.addEventListener('search', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
(() => {
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

  document.querySelectorAll('[data-search-section]').forEach((section) => {
    if (section.dataset.filterDrawerInitialized === 'true') return;
    section.dataset.filterDrawerInitialized = 'true';

    const drawer = section.querySelector('[data-search-filter-drawer]');
    const openButton = section.querySelector('[data-search-filter-open]');
    if (!drawer || !openButton) return;

    const panel = drawer.querySelector('.search-filter-drawer__panel');
    const closeButtons = drawer.querySelectorAll('[data-search-filter-close]');
    let returnFocus = null;

    const getFocusable = () => Array.from(panel.querySelectorAll(focusableSelector)).filter((element) => element.getClientRects().length > 0);

    const closeDrawer = () => {
      if (drawer.getAttribute('aria-hidden') === 'true') return;
      drawer.setAttribute('aria-hidden', 'true');
      openButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('search-filter-open');
      if (returnFocus && returnFocus.isConnected) returnFocus.focus({ preventScroll: true });
      returnFocus = null;
    };

    const openDrawer = () => {
      returnFocus = document.activeElement;
      drawer.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('search-filter-open');
      requestAnimationFrame(() => {
        const focusable = getFocusable();
        if (focusable.length) focusable[0].focus({ preventScroll: true });
        else panel.focus({ preventScroll: true });
      });
    };

    openButton.addEventListener('click', openDrawer);
    closeButtons.forEach((button) => button.addEventListener('click', closeDrawer));

    drawer.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = getFocusable();
      if (!focusable.length) {
        event.preventDefault();
        panel.focus();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-store-locator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-store-directory]').forEach((directory) => {
      if (directory.dataset.ready === 'true') return;
      directory.dataset.ready = 'true';
      const cards = [...directory.querySelectorAll('[data-store-card]')];
      const search = directory.querySelector('[data-store-search]');
      const regionButtons = [...directory.querySelectorAll('[data-region]')];
      const count = directory.querySelector('[data-store-count]');
      const empty = directory.querySelector('[data-store-empty]');
      const map = directory.querySelector('[data-store-map]');
      const mapTitle = directory.querySelector('[data-map-title]');
      const mapAddress = directory.querySelector('[data-map-address]');
      const mapDirections = directory.querySelector('[data-map-directions]');
      let region = 'all';

      const selectStore = (card) => {
        if (!card || !map) return;
        cards.forEach((item) => item.classList.toggle('is-selected', item === card));
        const query = card.dataset.mapQuery || '';
        const name = card.querySelector('.store-card__copy strong')?.textContent.trim() || section.dataset.storeFallback || 'ELC store';
        const address = card.querySelector('.store-card__copy span')?.textContent.trim() || '';
        map.src = `https://www.google.com/maps?q=${encodeURIComponent(query)}&output=embed`;
        map.title = `Map showing ${name}`;
        if (mapTitle) mapTitle.textContent = name;
        if (mapAddress) mapAddress.textContent = address;
        if (mapDirections) mapDirections.href = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
      };

      const render = () => {
        const query = (search?.value || '').trim().toLowerCase();
        let visible = 0;
        let firstVisible = null;
        cards.forEach((card) => {
          const text = `${card.dataset.storeName || ''} ${card.dataset.storeAddress || ''} ${card.dataset.storeRegion || ''}`;
          const matchesQuery = !query || text.includes(query);
          const matchesRegion = region === 'all' || card.dataset.storeRegion === region;
          const show = matchesQuery && matchesRegion;
          card.hidden = !show;
          if (show) { visible += 1; firstVisible ||= card; }
        });
        if (count) count.textContent = visible === 1 ? (section.dataset.storeOne || '1 store') : (section.dataset.stores || '__COUNT__ stores').replace('__COUNT__', String(visible));
        if (empty) empty.hidden = visible !== 0;
        const selected = cards.find((card) => card.classList.contains('is-selected') && !card.hidden);
        if (!selected && firstVisible) selectStore(firstVisible);
      };

      cards.forEach((card) => card.querySelector('[data-store-select]')?.addEventListener('click', () => selectStore(card)));
      search?.addEventListener('input', render);
      regionButtons.forEach((button) => button.addEventListener('click', () => {
        region = button.dataset.region || 'all';
        regionButtons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        render();
      }));
      render();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["predictive-search-controller"]) return;
  try {
    
(() => {
  const controller = document.querySelector('[data-predictive-search-controller]');
  if (!controller || controller.dataset.initialized === 'true') return;
  controller.dataset.initialized = 'true';

  const predictiveUrl = controller.dataset.predictiveUrl;
  const sectionId = controller.dataset.sectionId;
  const loadingText = controller.dataset.loadingText || 'Loading suggestions';
  const suggestionsLabel = controller.dataset.suggestionsLabel || 'Search suggestions';
  const cache = new Map();
  const cacheLimit = 20;
  const formSelectors = ['.site-search--desktop', '.mobile-search-modal__form', '.mobile-nav-search'];
  const normalizeTerm = (term) => term.trim().toLocaleLowerCase();

  const cacheSet = (key, value) => {
    if (cache.has(key)) cache.delete(key);
    cache.set(key, value);
    if (cache.size > cacheLimit) cache.delete(cache.keys().next().value);
  };

  const createHost = (form, index) => {
    if (form.closest('.predictive-search-host')) return;
    const input = form.querySelector('input[type="search"][name="q"]');
    if (!input) return;

    const host = document.createElement('div');
    host.className = 'predictive-search-host';
    host.dataset.predictiveHost = '';
    form.parentNode.insertBefore(host, form);
    host.appendChild(form);

    const panel = document.createElement('div');
    panel.className = 'predictive-search-panel';
    panel.id = `PredictiveSearch-${index}`;
    panel.hidden = true;
    panel.setAttribute('role', 'listbox');
    panel.setAttribute('aria-label', suggestionsLabel);
    panel.setAttribute('aria-busy', 'false');
    host.appendChild(panel);

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-haspopup', 'listbox');
    input.setAttribute('aria-controls', panel.id);
    input.setAttribute('aria-expanded', 'false');

    let debounceTimer = null;
    let requestController = null;
    let activeIndex = -1;
    let currentTerm = '';
    let allowOpen = false;

    const options = () => Array.from(panel.querySelectorAll('[data-predictive-option]'));

    const prepareOptions = () => {
      options().forEach((option, optionIndex) => {
        if (!option.id) option.id = `${panel.id}-Option-${optionIndex}`;
        option.setAttribute('role', 'option');
        option.setAttribute('aria-selected', 'false');
      });
    };

    const setExpanded = (expanded) => {
      panel.hidden = !expanded;
      input.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (!expanded) {
        activeIndex = -1;
        input.removeAttribute('aria-activedescendant');
        options().forEach((option) => {
          option.removeAttribute('data-active');
          option.setAttribute('aria-selected', 'false');
        });
      }
    };

    const close = ({ abort = false, dismiss = false } = {}) => {
      window.clearTimeout(debounceTimer);
      if (dismiss) allowOpen = false;
      if (abort && requestController) {
        requestController.abort();
        requestController = null;
      }
      panel.setAttribute('aria-busy', 'false');
      setExpanded(false);
    };

    const setActive = (nextIndex) => {
      const items = options();
      if (!items.length) return;
      activeIndex = (nextIndex + items.length) % items.length;
      items.forEach((item, itemIndex) => {
        const active = itemIndex === activeIndex;
        item.toggleAttribute('data-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        if (active) {
          input.setAttribute('aria-activedescendant', item.id);
          item.scrollIntoView({ block: 'nearest' });
        }
      });
    };

    const render = (html, term) => {
      if (!allowOpen || normalizeTerm(input.value) !== normalizeTerm(term)) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const section = doc.querySelector(`#shopify-section-${sectionId}`);
      panel.innerHTML = section ? section.innerHTML : '';
      panel.setAttribute('aria-busy', 'false');
      currentTerm = normalizeTerm(term);
      activeIndex = -1;
      prepareOptions();
      setExpanded(Boolean(panel.textContent.trim()));
    };

    const fetchResults = async (term) => {
      const cacheKey = normalizeTerm(term);
      if (!cacheKey || !allowOpen) return;
      if (cache.has(cacheKey)) {
        render(cache.get(cacheKey), term);
        return;
      }
      if (requestController) requestController.abort();
      const activeRequest = new AbortController();
      requestController = activeRequest;
      panel.innerHTML = `<p class="predictive-search-panel__loading" role="status" aria-live="polite">${loadingText}</p>`;
      panel.setAttribute('aria-busy', 'true');
      setExpanded(true);

      const params = new URLSearchParams();
      params.set('q', term);
      params.set('resources[type]', 'product,collection,query');
      params.set('resources[limit]', '6');
      params.set('resources[limit_scope]', 'each');
      params.set('resources[options][unavailable_products]', 'last');
      params.set('section_id', sectionId);

      try {
        const response = await fetch(`${predictiveUrl}?${params.toString()}`, {
          signal: activeRequest.signal,
          headers: { Accept: 'text/html' }
        });
        if (!response.ok) throw new Error(`Predictive search failed: ${response.status}`);
        const html = await response.text();
        cacheSet(cacheKey, html);
        render(html, term);
      } catch (error) {
        if (error.name !== 'AbortError') close();
      } finally {
        if (requestController === activeRequest) requestController = null;
      }
    };

    const scheduleSearch = () => {
      window.clearTimeout(debounceTimer);
      const term = input.value.trim();
      allowOpen = true;
      if (term.length < 2) {
        currentTerm = '';
        close({ abort: true });
        return;
      }
      debounceTimer = window.setTimeout(() => fetchResults(term), 180);
    };

    input.addEventListener('input', scheduleSearch);
    input.addEventListener('focus', () => {
      allowOpen = true;
      const term = input.value.trim();
      if (term.length < 2) return;
      if (normalizeTerm(term) === currentTerm && panel.textContent.trim()) setExpanded(true);
      else scheduleSearch();
    });
    input.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown') {
        if (panel.hidden) scheduleSearch();
        else {
          event.preventDefault();
          setActive(activeIndex + 1);
        }
      } else if (event.key === 'ArrowUp' && !panel.hidden) {
        event.preventDefault();
        setActive(activeIndex - 1);
      } else if (event.key === 'Enter' && activeIndex >= 0 && !panel.hidden) {
        const item = options()[activeIndex];
        if (item) {
          event.preventDefault();
          item.click();
        }
      } else if (event.key === 'Escape' && !panel.hidden) {
        event.preventDefault();
        event.stopPropagation();
        close({ abort: true, dismiss: true });
      }
    });
    form.addEventListener('submit', () => close({ abort: true, dismiss: true }));
    document.addEventListener('pointerdown', (event) => {
      if (!host.contains(event.target)) close({ abort: true, dismiss: true });
    });
  };

  const initialize = () => {
    let index = 0;
    formSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((form) => {
        createHost(form, index);
        index += 1;
      });
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sections = document.querySelectorAll('[data-product-recommendations]');
  if (!sections.length || !('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver((entries, instance) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      instance.unobserve(entry.target);
      const url = entry.target.dataset.url;
      if (!url) return;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const parsed = new DOMParser().parseFromString(text, 'text/html');
          const replacement = parsed.querySelector('[data-product-recommendations]');
          if (!replacement || !replacement.innerHTML.trim()) return;
          entry.target.innerHTML = replacement.innerHTML;
          document.dispatchEvent(new CustomEvent('elc:carousel:refresh', { detail: { scope: entry.target } }));
        })
        .catch(() => {});
    });
  }, { rootMargin: '0px 0px 280px 0px' });

  sections.forEach((section) => observer.observe(section));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  var STAR_ACTIVE='#f6c344';
  var STAR_IDLE='#cdd7d1';

  function initReviews(root){
    if(!root||root.dataset.reviewUiReady==='true')return;
    root.dataset.reviewUiReady='true';
    var allDialog=root.querySelector('[data-review-all-dialog]');
    var allOpen=root.querySelector('[data-review-all-open]');
    var allTemplate=root.querySelector('[data-review-all-template]');
    var allList=root.querySelector('[data-review-all-list]');
    var allLoadMore=root.querySelector('[data-review-all-load-more]');
    var allClose=root.querySelector('[data-review-all-close]');
    var allCards=[];
    var allLoaded=0;
    var batchSize=10;

    if(allDialog&&allOpen&&allList){
      root.querySelectorAll('[data-review-card-main]').forEach(function(card){allCards.push(card);});
      if(allTemplate&&allTemplate.content)allTemplate.content.querySelectorAll('[data-review-all-card]').forEach(function(card){allCards.push(card);});

      function appendReviewBatch(reset){
        if(reset){allList.innerHTML='';allLoaded=0;}
        var end=Math.min(allLoaded+batchSize,allCards.length);
        for(var i=allLoaded;i<end;i++)allList.appendChild(allCards[i].cloneNode(true));
        allLoaded=end;
        if(allLoadMore)allLoadMore.hidden=allLoaded>=allCards.length;
      }

      allOpen.addEventListener('click',function(){
        appendReviewBatch(true);
        if(typeof allDialog.showModal==='function')allDialog.showModal();else allDialog.setAttribute('open','');
      });
      if(allLoadMore)allLoadMore.addEventListener('click',function(){appendReviewBatch(false);});
      if(allClose)allClose.addEventListener('click',function(){allDialog.close();});
      allDialog.addEventListener('click',function(event){if(event.target===allDialog)allDialog.close();});
    }

    var dialog=root.querySelector('[data-review-dialog]');
    if(!dialog)return;
    var formWrap=dialog.querySelector('.product-reviews__form-wrap');
    var productGid=root.getAttribute('data-review-product-gid')||'';
    var fieldSelector='input:not([type="radio"]):not([type="checkbox"]):not([type="submit"]):not([type="hidden"]):not([type="button"]):not([type="reset"]),textarea,select';

    function findLabel(control,scope){
      if(!control)return null;
      if(control.labels&&control.labels.length)return control.labels[0];
      if(control.closest){var wrapping=control.closest('label');if(wrapping)return wrapping;}
      if(!control.id||!scope||!scope.querySelectorAll)return null;
      var labels=scope.querySelectorAll('label[for]');
      for(var i=0;i<labels.length;i++)if(labels[i].getAttribute('for')===control.id)return labels[i];
      return null;
    }

    function enhanceFields(scope){
      if(!scope||!scope.querySelectorAll)return;
      scope.querySelectorAll(fieldSelector).forEach(function(control){
        if(control.classList.contains('product-reviews__field-control'))return;
        control.classList.add('product-reviews__field-control');
        var label=findLabel(control,scope);
        if(!label)return;
        label.classList.add('product-reviews__field-label');
        var shell=control.parentElement;
        if(shell){shell.classList.add('product-reviews__field-shell');if(label.parentElement!==shell||label.nextElementSibling!==control)shell.insertBefore(label,control);}
      });
    }

    function setControlValue(control,value){
      if(!control||!value||control.value===value)return;
      var view=control.ownerDocument&&control.ownerDocument.defaultView;
      var prototype=null;
      if(view){
        if(control.tagName==='TEXTAREA'&&view.HTMLTextAreaElement)prototype=view.HTMLTextAreaElement.prototype;
        else if(view.HTMLInputElement)prototype=view.HTMLInputElement.prototype;
      }
      var descriptor=prototype&&Object.getOwnPropertyDescriptor(prototype,'value');
      if(descriptor&&descriptor.set)descriptor.set.call(control,value);else control.value=value;
      control.setAttribute('value',value);
      var EventCtor=view&&view.Event?view.Event:Event;
      control.dispatchEvent(new EventCtor('input',{bubbles:true,composed:true}));
      control.dispatchEvent(new EventCtor('change',{bubbles:true,composed:true}));
    }

    function installProductId(scope){
      if(!productGid||!scope||!scope.querySelectorAll)return false;
      var matched=false;
      scope.querySelectorAll(fieldSelector).forEach(function(control){
        if(matched)return;
        var label=findLabel(control,scope);
        var labelText=(label&&label.textContent||'').replace(/\s+/g,' ').trim().toLowerCase();
        var placeholder=(control.getAttribute('placeholder')||'').trim().toLowerCase();
        var ariaLabel=(control.getAttribute('aria-label')||'').trim().toLowerCase();
        var name=(control.getAttribute('name')||'').trim().toLowerCase();
        var isProductId=labelText==='product id'||placeholder==='product id'||ariaLabel==='product id'||name.indexOf('product_id')!==-1||name.indexOf('productid')!==-1;
        if(!isProductId)return;
        setControlValue(control,productGid);
        control.setAttribute('tabindex','-1');
        control.setAttribute('autocomplete','off');
        var shell=control.closest?control.closest('.product-reviews__field-shell'):null;
        if(!shell)shell=control.parentElement;
        if(shell){
          shell.hidden=true;
          shell.setAttribute('aria-hidden','true');
          if(shell.style)shell.style.setProperty('display','none','important');
        }
        matched=true;
      });
      return matched;
    }

    function collectScopes(base){
      var scopes=[];
      var seen=[];
      function walk(scope){
        if(!scope||seen.indexOf(scope)!==-1)return;
        seen.push(scope);scopes.push(scope);
        if(!scope.querySelectorAll)return;
        scope.querySelectorAll('*').forEach(function(el){
          if(el.shadowRoot)walk(el.shadowRoot);
          if(el.tagName==='IFRAME'){
            try{if(el.contentDocument)walk(el.contentDocument);}catch(e){}
          }
        });
      }
      walk(base);
      return scopes;
    }

    function optionText(input,scope){
      var parts=[];
      var label=findLabel(input,scope);
      if(label)parts.push(label.textContent||'');
      if(input.getAttribute('aria-label'))parts.push(input.getAttribute('aria-label'));
      if(input.value)parts.push(input.value);
      var node=input.parentElement;
      for(var i=0;i<3&&node;i++,node=node.parentElement)parts.push(node.textContent||'');
      return parts.join(' ').replace(/\s+/g,' ').trim();
    }

    function ratingFrom(input,scope){
      var text=optionText(input,scope);
      var match=text.match(/(?:^|\s)([1-5])\s*[-–—]\s*(?:Excellent|Good|Average|Poor|Very\s+poor)/i);
      if(match)return parseInt(match[1],10);
      match=text.match(/^\s*([1-5])(?:\s|$)/);
      if(match)return parseInt(match[1],10);
      var value=parseInt(input.value,10);
      return value>=1&&value<=5?value:0;
    }

    function ratingRow(input,scope,rating){
      var node=input.closest?input.closest('label'):null;
      if(node)return node;
      node=input.parentElement;
      var best=node;
      for(var i=0;i<4&&node;i++,node=node.parentElement){
        var text=(node.textContent||'').replace(/\s+/g,' ');
        var hits=text.match(/[1-5]\s*[-–—]\s*(?:Excellent|Good|Average|Poor|Very\s+poor)/gi)||[];
        if(hits.length===1)best=node;
        if(hits.length>1)break;
      }
      return best||input;
    }

    function styleStarButton(button){
      button.style.setProperty('appearance','none','important');
      button.style.setProperty('-webkit-appearance','none','important');
      button.style.setProperty('border','0','important');
      button.style.setProperty('background','transparent','important');
      button.style.setProperty('padding','0','important');
      button.style.setProperty('margin','0','important');
      button.style.setProperty('width','36px','important');
      button.style.setProperty('height','36px','important');
      button.style.setProperty('font-size','33px','important');
      button.style.setProperty('line-height','1','important');
      button.style.setProperty('cursor','pointer','important');
      button.style.setProperty('display','grid','important');
      button.style.setProperty('place-items','center','important');
      button.style.setProperty('color',STAR_IDLE,'important');
    }

    function hideNativeRow(row){
      if(!row||!row.style)return;
      row.classList&&row.classList.add('product-reviews__rating-native-hidden');
      row.style.setProperty('position','absolute','important');
      row.style.setProperty('width','1px','important');
      row.style.setProperty('height','1px','important');
      row.style.setProperty('overflow','hidden','important');
      row.style.setProperty('clip-path','inset(50%)','important');
      row.style.setProperty('opacity','0.001','important');
      row.style.setProperty('pointer-events','none','important');
    }

    function installStars(scope){
      if(!scope||!scope.querySelectorAll)return false;
      if(scope.querySelector('[data-elc-rating-stars="true"]'))return true;
      var ratingInputs=Array.prototype.slice.call(scope.querySelectorAll('input[type="radio"],input[type="checkbox"]'));
      if(ratingInputs.length<5)return false;
      var candidates=[];
      ratingInputs.forEach(function(input){
        var rating=ratingFrom(input,scope);
        if(!rating)return;
        candidates.push({input:input,rating:rating,row:ratingRow(input,scope,rating)});
      });
      var options=[];
      [1,2,3,4,5].forEach(function(rating){
        var match=candidates.find(function(option){return option.rating===rating;});
        if(match)options.push(match);
      });
      if(options.length!==5)return false;
      options.sort(function(a,b){return a.rating-b.rating;});
      var firstRow=options[0].row;
      if(!firstRow||!firstRow.parentNode)return false;
      var host=firstRow.parentNode;
      var stars=(scope.ownerDocument||document).createElement('div');
      stars.className='product-reviews__rating-stars-v2';
      stars.setAttribute('data-elc-rating-stars','true');
      stars.setAttribute('role','radiogroup');
      stars.setAttribute('aria-label','Rating');
      stars.style.setProperty('display','flex','important');
      stars.style.setProperty('align-items','center','important');
      stars.style.setProperty('gap','3px','important');
      stars.style.setProperty('margin','4px 0 14px','important');
      host.insertBefore(stars,firstRow);

      var buttons=[];
      function selectedRating(){
        var selected=0;
        options.forEach(function(o){if(o.input.checked)selected=o.rating;});
        return selected;
      }
      function paint(value){buttons.forEach(function(b){var active=parseInt(b.dataset.rating,10)<=value;b.classList.toggle('is-active',active);b.style.setProperty('color',active?STAR_ACTIVE:STAR_IDLE,'important');});}

      options.forEach(function(option){
        hideNativeRow(option.row);
        var button=(scope.ownerDocument||document).createElement('button');
        button.type='button';button.textContent='★';button.dataset.rating=String(option.rating);button.setAttribute('aria-label',option.rating+' out of 5 stars');button.setAttribute('title',option.rating+' out of 5 stars');
        styleStarButton(button);stars.appendChild(button);buttons.push(button);
        button.addEventListener('mouseenter',function(){paint(option.rating);});
        button.addEventListener('focus',function(){paint(option.rating);});
        button.addEventListener('click',function(){
          options.forEach(function(other){if(other.input!==option.input&&other.input.type==='checkbox')other.input.checked=false;});
          option.input.checked=true;
          option.input.dispatchEvent(new Event('input',{bubbles:true,composed:true}));
          option.input.dispatchEvent(new Event('change',{bubbles:true,composed:true}));
          paint(option.rating);
        });
        option.input.addEventListener('change',function(){paint(selectedRating());});
      });
      stars.addEventListener('mouseleave',function(){paint(selectedRating());});
      paint(selectedRating());
      return true;
    }

    function syncSuccessState(){
      if(!formWrap)return;
      var text=(formWrap.textContent||'').replace(/\s+/g,' ').toLowerCase();
      var success=text.indexOf('thanks for your review')!==-1&&text.indexOf('submitted')!==-1;
      dialog.classList.toggle('product-reviews__dialog--success',success);
      root.querySelectorAll('.product-reviews__app').forEach(function(app){app.classList.toggle('product-reviews__app--success',success);});
    }

    function syncFormUi(){
      collectScopes(formWrap).forEach(function(scope){enhanceFields(scope);installProductId(scope);installStars(scope);});
      syncSuccessState();
    }

    var retryTimer=null;
    function retryForInjectedForm(){
      if(retryTimer)clearInterval(retryTimer);
      var attempts=0;
      syncFormUi();
      retryTimer=setInterval(function(){attempts++;syncFormUi();if(attempts>=30||formWrap.querySelector('[data-elc-rating-stars="true"]')){clearInterval(retryTimer);retryTimer=null;}},150);
    }

    var formObserver=null;
    function ensureFormObserver(){
      if(formObserver||typeof MutationObserver==='undefined')return;
      formObserver=new MutationObserver(function(){syncFormUi();});
      formObserver.observe(formWrap,{childList:true,subtree:true});
    }

    root.querySelectorAll('[data-review-open]').forEach(function(button){button.addEventListener('click',function(){if(typeof dialog.showModal==='function')dialog.showModal();else dialog.setAttribute('open','');ensureFormObserver();retryForInjectedForm();requestAnimationFrame(syncFormUi);});});
    var closeButton=dialog.querySelector('[data-review-close]');if(closeButton)closeButton.addEventListener('click',function(){dialog.close();});
    dialog.addEventListener('click',function(event){if(event.target===dialog)dialog.close();});
  }

  document.querySelectorAll('[data-product-reviews-root]').forEach(initReviews);
  document.addEventListener('shopify:section:load',function(event){var root=event.target.matches&&event.target.matches('[data-product-reviews-root]')?event.target:event.target.querySelector&&event.target.querySelector('[data-product-reviews-root]');initReviews(root);});
  document.addEventListener('shopify:block:select',function(event){var root=event.target.closest&&event.target.closest('[data-product-reviews-root]');if(!root)return;initReviews(root);var dialog=root.querySelector('[data-review-dialog]');if(dialog&&!dialog.open&&typeof dialog.showModal==='function'){dialog.showModal();var button=root.querySelector('[data-review-open]');if(button)button.click();}});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-recently-viewed-products]';
  const storageKey = 'elc:recently-viewed:v1';
  const historyLimit = 12;
  const internalProductHandles = new Set([
    'elc-free-gift-redemption',
    'elc-free-gift-redemption-2'
  ]);

  function readHistory() {
    try {
      const value = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      if (!Array.isArray(value)) return [];
      return value.filter((handle) => typeof handle === 'string' && handle.length > 0 && handle.length <= 255);
    } catch (error) {
      return [];
    }
  }

  function writeHistory(handles) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(handles.slice(0, historyLimit)));
    } catch (error) {}
  }

  function isInternalHandle(handle) {
    return internalProductHandles.has(handle) || handle.startsWith('elc-free-gift-redemption-');
  }

  async function fetchCard(root, handle) {
    if (isInternalHandle(handle)) return { handle, ineligible: true };

    const sectionId = root.dataset.sectionId;
    const routeRoot = window.Shopify?.routes?.root || '/';
    const url = new URL(`${routeRoot}products/${encodeURIComponent(handle)}`, window.location.origin);
    url.searchParams.set('section_id', sectionId);

    try {
      const response = await fetch(url.toString(), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (response.status === 404) return { handle, ineligible: true };
      if (!response.ok) return { handle };

      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const template = parsed.querySelector('[data-recently-viewed-card-template]');
      const card = template?.content?.querySelector('.product-card');
      if (!card) return { handle, ineligible: true };

      const titleLink = card.querySelector('.product-card__title a');
      const title = titleLink?.textContent?.trim() || '';
      const hasRealImage = Boolean(card.querySelector('.product-card__media img'));
      const isSoldOut = Boolean(card.querySelector('.product-card__sold-out'));
      const productUrl = titleLink?.getAttribute('href') || card.querySelector('.product-card__media')?.getAttribute('href') || '';
      const isInternalProduct = isInternalHandle(handle) || productUrl.includes('/products/elc-free-gift-redemption');

      if (!title || !hasRealImage || isSoldOut || isInternalProduct) {
        return { handle, ineligible: true };
      }

      return { handle, card: document.importNode(card, true) };
    } catch (error) {
      return { handle };
    }
  }

  function init(root) {
    if (root.dataset.recentlyViewedInitialized === 'true') return;
    root.dataset.recentlyViewedInitialized = 'true';

    const currentHandle = root.dataset.productHandle?.trim();
    const content = root.querySelector('[data-recently-viewed-content]');
    const trigger = root.querySelector('[data-recently-viewed-trigger]');
    const track = root.querySelector('[data-carousel-track]');
    if (!currentHandle || !content || !trigger || !track) return;

    const stored = readHistory();
    const previous = stored.filter((handle, index, items) => handle !== currentHandle && !isInternalHandle(handle) && items.indexOf(handle) === index);

    if (isInternalHandle(currentHandle)) {
      writeHistory(previous);
      return;
    }

    writeHistory([currentHandle, ...previous]);

    const limit = Math.min(8, Math.max(1, Number(root.dataset.limit) || 8));
    const targets = previous.slice(0, historyLimit);
    if (!targets.length) return;

    let loaded = false;
    const load = async () => {
      if (loaded) return;
      loaded = true;

      const results = await Promise.all(targets.map((handle) => fetchCard(root, handle)));
      const eligibleResults = results.filter((result) => result.card).slice(0, limit);
      const fragment = document.createDocumentFragment();

      eligibleResults.forEach((result) => {
        const item = document.createElement('li');
        item.className = 'recently-viewed__slide';
        item.append(result.card);
        fragment.append(item);
      });

      const ineligible = new Set(results.filter((result) => result.ineligible).map((result) => result.handle));
      if (ineligible.size) {
        writeHistory([currentHandle, ...previous.filter((handle) => !ineligible.has(handle))]);
      }
      if (!fragment.childNodes.length) return;

      track.replaceChildren(fragment);
      content.hidden = false;
      document.dispatchEvent(new CustomEvent('elc:carousel:refresh', { detail: { scope: root } }));
    };

    if (!('IntersectionObserver' in window)) {
      load();
      return;
    }

    const observer = new IntersectionObserver((entries, instance) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      instance.disconnect();
      load();
    }, { rootMargin: '800px 0px' });

    observer.observe(trigger);
  }

  function initAll(scope = document) {
    if (scope.matches?.(selector)) init(scope);
    scope.querySelectorAll?.(selector).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-discovery"]) return;
  try {
    
(() => {
  const positionDiscovery = () => {
    if (window.Shopify && window.Shopify.designMode) return;

    const searchPage = document.querySelector('[data-search-section]');
    const discovery = document.querySelector('[data-search-discovery]');
    if (!searchPage || !discovery) return;

    const activeFilters = searchPage.querySelector('.search-page__active-filters');
    const toolbar = searchPage.querySelector('.search-page__toolbar');
    const anchor = activeFilters || toolbar;
    if (!anchor) return;

    const wrapper = discovery.closest('.shopify-section');
    const movable = wrapper || discovery;
    if (anchor.nextElementSibling !== movable) anchor.insertAdjacentElement('afterend', movable);

    discovery.classList.remove('page-width');
    discovery.dataset.positioned = 'true';
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionDiscovery, { once: true });
  } else {
    positionDiscovery();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-strip"] && !Shopify.designMode) return;
  try {
    
(function(){
  const mobileQuery=window.matchMedia('(max-width: 749px)');
  const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)');

  function cleanClone(clone){
    clone.setAttribute('aria-hidden','true');
    clone.setAttribute('data-trust-clone','true');
    clone.removeAttribute('data-shopify-editor-block');
    clone.querySelectorAll('[data-shopify-editor-block]').forEach((node)=>node.removeAttribute('data-shopify-editor-block'));
    clone.querySelectorAll('[id]').forEach((node)=>node.removeAttribute('id'));
    clone.querySelectorAll('img').forEach((image)=>{image.draggable=false;});
    return clone;
  }

  function initCarousel(carousel){
    if(carousel.dataset.initialized==='true')return;
    const viewport=carousel.querySelector('[data-trust-viewport]');
    const track=carousel.querySelector('[data-trust-track]');
    if(!viewport||!track)return;
    const originals=[...track.querySelectorAll('[data-trust-item]')];
    if(originals.length<1)return;

    carousel.dataset.initialized='true';
    let index=0;
    let timer=null;
    let resetTimer=null;
    let pointerId=null;
    let pointerStartX=0;
    let pointerCurrentX=0;
    let dragging=false;
    const autoplay=false;
    const interval=Math.max(Number(carousel.dataset.interval)||4000,2500);
    const rtl=getComputedStyle(carousel).direction==='rtl';
    const motionSign=rtl?1:-1;

    viewport.addEventListener('dragstart',(event)=>event.preventDefault());
    originals.forEach((item)=>item.querySelectorAll('img').forEach((image)=>{image.draggable=false;}));

    const getStep=()=>{
      const first=track.querySelector('[data-trust-item]:not([data-trust-clone])');
      if(!first)return 0;
      const styles=getComputedStyle(track);
      const gap=parseFloat(styles.columnGap||styles.gap||0)||0;
      return first.getBoundingClientRect().width+gap;
    };

    const moveTo=(next,animate=true)=>{
      index=next;
      track.style.transition=animate?'transform .42s cubic-bezier(.22,.61,.36,1)':'none';
      track.style.transform=`translate3d(${motionSign*index*getStep()}px,0,0)`;
    };

    const stop=()=>{if(timer)window.clearInterval(timer);timer=null;};
    const removeClones=()=>{track.querySelectorAll('[data-trust-clone]').forEach((clone)=>clone.remove());};

    const resetDesktop=()=>{
      stop();
      window.clearTimeout(resetTimer);
      removeClones();
      index=0;
      pointerId=null;
      dragging=false;
      viewport.classList.remove('is-dragging');
      viewport.style.cursor='';
      track.style.transition='none';
      track.style.transform='none';
    };

    const normalize=()=>{
      if(index<originals.length)return;
      index=0;
      moveTo(0,false);
      requestAnimationFrame(()=>requestAnimationFrame(()=>{track.style.transition='transform .42s cubic-bezier(.22,.61,.36,1)';}));
    };

    const advance=()=>{
      if(!mobileQuery.matches||originals.length<3)return;
      const next=index+1;
      moveTo(next,true);
      if(next===originals.length){
        window.clearTimeout(resetTimer);
        resetTimer=window.setTimeout(normalize,440);
      }
    };

    const retreat=()=>{
      if(!mobileQuery.matches||originals.length<3)return;
      if(index>0){moveTo(index-1,true);return;}
      index=originals.length;
      moveTo(index,false);
      requestAnimationFrame(()=>requestAnimationFrame(()=>moveTo(originals.length-1,true)));
    };

    const start=()=>{
      stop();
      if(autoplay&&mobileQuery.matches&&!reducedMotion.matches&&originals.length>2){
        timer=window.setInterval(advance,interval);
      }
    };

    const setupMobile=()=>{
      resetDesktop();
      if(!mobileQuery.matches)return;
      viewport.style.cursor=originals.length>2?'grab':'';
      if(originals.length<=2)return;
      originals.forEach((item)=>track.appendChild(cleanClone(item.cloneNode(true))));
      moveTo(0,false);
      start();
    };

    viewport.addEventListener('pointerdown',(event)=>{
      if(!mobileQuery.matches||originals.length<=2||event.button!==0||event.isPrimary===false)return;
      pointerId=event.pointerId;
      pointerStartX=pointerCurrentX=event.clientX;
      dragging=false;
      stop();
      viewport.style.cursor='grabbing';
      viewport.setPointerCapture?.(event.pointerId);
    },{passive:true});

    viewport.addEventListener('pointermove',(event)=>{
      if(pointerId===null||event.pointerId!==pointerId)return;
      pointerCurrentX=event.clientX;
      const dx=pointerCurrentX-pointerStartX;
      if(Math.abs(dx)>6){dragging=true;viewport.classList.add('is-dragging');}
    },{passive:true});

    const endDrag=(event)=>{
      if(pointerId===null||event.pointerId!==pointerId)return;
      const dx=(event.clientX||pointerCurrentX)-pointerStartX;
      if(dragging&&Math.abs(dx)>34){if(dx*motionSign>0)advance();else retreat();}
      try{viewport.releasePointerCapture(pointerId);}catch(error){}
      pointerId=null;
      dragging=false;
      viewport.classList.remove('is-dragging');
      viewport.style.cursor='grab';
      start();
    };

    viewport.addEventListener('pointerup',endDrag,{passive:true});
    viewport.addEventListener('pointercancel',endDrag,{passive:true});
    window.addEventListener('resize',()=>{if(mobileQuery.matches)moveTo(index,false);},{passive:true});
    mobileQuery.addEventListener?.('change',setupMobile);
    reducedMotion.addEventListener?.('change',setupMobile);
    setupMobile();
  }

  function setup(root=document){root.querySelectorAll?.('[data-trust-carousel]').forEach(initCarousel);}
  setup();
  document.addEventListener('shopify:section:load',(event)=>setup(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
